import Article from "components/Content/RelatedArticles/Article";
import ArticleType from "components/Content/RelatedArticles/PropTypes/ArticleType";
import i18n from "lib/i18n";
import PropTypes from "prop-types";
import React from "react";
import Spinner from "components/Spinner";

import styles from "./styles.scss";

const LAST_ARTICLE_INDEX = 3;

export default function RelatedArticles({ articles, error, loading }) {
  const articleSummaries = articles.map((item, index) =>
    <Article key={item.url} article={item} last={index === LAST_ARTICLE_INDEX} />
  );

  if (error) { return <React.Fragment />; }

  return (
    <div className="grid-sixteen">
      <h3 className="border slammed">
        {i18n.t("content.heading.related_articles")}
      </h3>

      <div className={styles.articles}>
        {loading ? <Spinner /> : articleSummaries}
      </div>
    </div>
  );
}

RelatedArticles.propTypes = {
  articles: PropTypes.arrayOf(ArticleType).isRequired,
  error: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
};
